<!--
 * @Author: huanglin.like@qq.com
 * @LastEditTime: 2023-12-01 16:44:22
-->
<template>
  <div>
    <com-page>
      <com-recharge-search @search="handleSearch"></com-recharge-search>
      <com-card>
        <div class="flex justify-between items-center mb-15px">
          <div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="全部" name="all"></el-tab-pane>
              <el-tab-pane label="钱包充值" name="WALLET"></el-tab-pane>
              <el-tab-pane label="代充值" name="CARD"></el-tab-pane>
            </el-tabs>
          </div>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </div>
        <com-recharge-list
          ref="table"
          typeOfView="rechargeOrder"
          :query="defaultQuery"
        ></com-recharge-list>
      </com-card>
    </com-page>
  </div>
</template>

<script>
import { exportExcel } from '@/utils/index'
import { formatDate } from '@/filters'
import { rechargeListApi } from '@/api/order'

export default {
  data() {
    return {
      exportQuery: {
        pageIndex: 1,
        pageSize: 200
      },
      activeName: 'all',
      defaultQuery: {},
      exportList: []
    }
  },
  methods: {
    handleSearch(val) {
      this.exportQuery = { pageIndex: 1, pageSize: 200, ...val }
      this.$refs.table.search(val)
    },
    async handleExport() {
      this.$message.info('请稍等,正在导出...')
      const query = {
        ...this.exportQuery,
        type: this.activeName === 'all' ? '' : this.activeName
      }

      try {
        const {
          data: {
            pager: { pageCount }
          }
        } = await rechargeListApi(query)

        this.exportList = [] // 初始化exportList

        for (let i = 1; i <= pageCount; i += 1) {
          query.pageIndex = i
          const res = await rechargeListApi(query)
          this.exportList = [...this.exportList, ...res.data.records]
        }

        this.export() // 等待所有数据加载完成后调用
      } catch (error) {
        this.$message.error('导出失败,请重新导出')
      }
    },

    export() {
      const newArr = []
      this.exportList.forEach((item) => {
        const params = {
          订单编号: item.number,
          流水号: item.transactionId,
          网点名称: item.storeName,
          用户ID: item.refUserNumber,
          手机号: item.refUserPhone,
          充值金额: item.paySum,
          充值方式: item.payType,
          充值时间: formatDate(item.createTime)
        }
        newArr.push(params)
        console.log('item :>> ', item)
      })
      exportExcel(newArr, '充值订单')
    },
    handleClick({ name }) {
      console.log('object :>> ', name)
      const params = {
        type: name === 'all' ? '' : name
      }
      this.defaultQuery = params
    }
  }
}
</script>

<style lang="scss" scoped></style>
